import styled from '@emotion/styled'

const CardLabelContainer = styled.div`
  ${({ theme }) => `
    margin: ${theme.spacing(1)}px;
  `}
  display: flex;
  overflow: hidden;
  white-space: nowrap;
  flex-wrap: nowrap;
  align-items: center;
  flex-grow: 1;
`

interface ChipWrapperProps {
  $visible: boolean
}

const ChipWrapper = styled.div<ChipWrapperProps>`
  white-space: nowrap;
  position: ${({ $visible }) => ($visible ? 'static' : 'absolute')};
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
  user-select: ${({ $visible }) => ($visible ? 'auto' : 'none')};
`

interface MoreChipWrapperProps {
  $visible: boolean;
}

const MoreChipWrapper = styled.div<MoreChipWrapperProps>`
  white-space: nowrap;
  position: ${({ $visible }) => ($visible ? 'static' : 'absolute')};
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
  user-select: ${({ $visible }) => ($visible ? 'auto' : 'none')};
  height: ${({ $visible }) => ($visible ? 'auto' : 0)};
  overflow: hidden;
`

export {
  CardLabelContainer,
  ChipWrapper,
  MoreChipWrapper,
}
